import React from 'react'
import Sentry from './sentry'

interface EBProps {}

interface EBState {
  hasError: boolean
  error?: Error
}

export default class ErrorBoundary extends React.Component<EBProps, EBState> {
  constructor(props: EBProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    return { error, hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    Sentry.withScope(scope => {
      scope.setExtra("errorInfo", errorInfo)
      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.hasError) {
      return <p>
        問題が発生しました。もう一度お試しください。
      </p>
    }

    return this.props.children
  }
}
